import { render, staticRenderFns } from "./administrationFormCreator.vue?vue&type=template&id=fbbfb498&"
import script from "./administrationFormCreator.vue?vue&type=script&lang=js&"
export * from "./administrationFormCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports